import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../styles/colors';

const StyledFooter = styled.footer`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;

  background-color: ${Colors.white};
  padding: ${props => props['desktop'] ? '1rem 2rem' : '2rem'};
  font-weight: 700;
  font-size: ${props => props['desktop'] ? '.75rem' : '.9375rem'};
`;

export const Footer: FC<{ desktop?: boolean }> = (props) => {
  const { desktop = false } = props;

  return (
    <StyledFooter {...{ desktop }}>DEW21 • Dortmunder Energie- und Wasserversorgung GmbH • Günter-Samtlebe-Platz 1 • 44135 Dortmund</StyledFooter>
  );
};
